// import { getSelectables } from "./getSelectables";
// import { getApplyReadOnly } from "./getApplyReadOnly";
// import { getSelectablesFromTable } from "./getSelectablesFromTable";
var schema = [
  {
    name: "Created By",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Creator UID",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Creator Email",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 254,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Created Date",
    default: null,
    nullable: false,
    type: "date",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Modifier UID",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Modified By",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Modifier Email",
    default: null,
    nullable: false,
    type: "string",
    maxLength: 254,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
  {
    name: "Modified Date",
    default: null,
    nullable: false,
    type: "date",
    maxLength: 80,
    selectables: [],
    readOnly: false,
    helperText: "",
    error: false,
  },
];

export function getEditorTrackingFields() {
  // var schema = \\await getFeatures("schemas", "tableName", tablename);

  return schema;
}


export function getEditorTrackingFieldNames() {
  return schema.map((field) => field.name);
}